(function () {
  /**
   * @awaitingdeprecation
   *
   * @ngdoc factory
   * @name AnalyticsPageDescriptor
   * @description  This class describes an analytics page change
   */
  angular.module('binky.core.analytics-page').factory('AnalyticsPageDescriptor', factory);

  function factory(_, binkySrc2, feature) {
    /**
     * @description ProductDescriptor class on AngularJS
     * @deprecated
     */
    class AnalyticsPageDescriptor {
      /**
       * @description Constructor
       *
       * @param {Object} [options] Initialization options
       * @param {String} [options.name] Analytics state name
       */
      constructor(options = {}) {
        initModel(this, options);
      }
    }

    /**
     * @description AnalyticsPageDescriptor class based on React model
     */
    class AnalyticsPageDescriptor2 extends binkySrc2.services.analytics.AnalyticsPageDescriptor {}

    return feature.isEnabled('temp_react_port_analytics_descriptors')
      ? AnalyticsPageDescriptor2
      : AnalyticsPageDescriptor;

    //////////

    function initModel(model, options) {
      _.assignIn(model, _.pick(options, ['name']));
    }
  }
})();
